import './TableauEmbed.scss';
import { PropsWithChildren } from 'react';

interface TableauEmbedProps extends PropsWithChildren {
  src: string;
  token: string | undefined;
  hideTabs?: boolean;
}

// Shared <tableau-viz> wrapper for CustomDashboard and AmcTableau — both pages embed a Tableau
// dashboard the same way, differing only in the dashboard's src and an optional <viz-filter> child.
export const TableauEmbed = ({ src, token, hideTabs = false, children }: TableauEmbedProps) => (
  <div className='tableau-embed'>
    <tableau-viz
      src={src}
      id='tableauViz'
      hideTabs={hideTabs}
      iframe-auth
      token={token}
      toolbar='bottom'
    >
      {children}
    </tableau-viz>
  </div>
);
